'use strict'

AddressInput = require '../../address_input/frontend/address_input'
MarkerTooltip = require './marker_tooltip'

module.exports = class OffersMapAddressInput

  templates:
    mapMarker: require '../map_marker.html.mustache'
    tooltip: require '../tooltip.html.mustache'

  constructor: ({ @$el, @$icon, @offersMap }) ->
    @addressInput = new AddressInput {
      el: @$el
      onSubmit: @submit
      placeholder: I18n.t 'js.modules.offers_map.address_input.placeholder'
    }

  submit: =>
    return unless @addressInput.value().length > 5

    @showLoading()

    @addressInput.getAddressDetails (err, address) =>
      @hideLoading()
      return @addressInput.clear() if err? or not (address?.lat? and address?.lon?)
      @offersMap.map.setCenter(new google.maps.LatLng address.lat, address.lon)
      @offersMap.fetchAndUpdatePlacesForMapInView()
      @addMarker address

  showLoading: ->
    @$icon.addClass 'icon-g-loader'

  hideLoading: ->
    @$icon.removeClass 'icon-g-loader'

  removeMarker: ->
    @$marker?.remove()
    @marker?.setMap null

  addMarker: (address) ->
    @removeMarker()

    tooltipData =
      name: "#{address.street}, #{address.city}"

    data =
      label: '<span class="icon-star-filled"></span>'
      tooltipHtml: @templates.tooltip.render tooltipData

    @$marker = $ @templates.mapMarker.render(data)
    @$marker.find('.marker-label').addClass 'default-cursor'
    $tooltip = @$marker.find '.marker-tooltip'

    @marker = new RichMarker
      position: new google.maps.LatLng address.lat, address.lon
      map: @offersMap.map
      draggable: false
      shadow: false
      content: @$marker[0]

    tooltip = new MarkerTooltip
      marker: @marker
      $hoverElement: @$marker.find '.marker-label'
      $mapContainer: @$el.closest '.map-container'
      $tooltip: $tooltip
      $marker: @$marker
